<template>
  <div class="home-content-page-v">
    <div class="one-content">
      <mii-table :datas="centroids" :table_style="2" :ths="thsCentroids" title="车辆配送信息"></mii-table>
    </div>
    <div class="gu-duan">
      <el-select v-model="show_order_car" placeholder="请选择车辆类型">
        <el-option v-for="item in cars" :key="item" :label="item" :value="item">
        </el-option>
      </el-select>
    </div>
    <div class="two-content">
      <div class="content-1">
        <mii-table :datas="carOrders" :table_style="1" :ths="ths" :title="sourceDataType === 'shop' ? '订单重量' : '订单量'"></mii-table>
      </div>
      <div class="content-2">
        <content-title title="柱状图展示"></content-title>
        <div class="car-echart">
          <echarts chart_id="car-echart" :style="echarts_option.outOption.style" :option="echarts_option.option"></echarts>
        </div>
      </div>
    </div>
    <div style="display: none">
      {{echarts_option}}
    </div>
  </div>
</template>

<script>
  import MiiTable from '../components_bit/MiiTable'
  import ContentTitle from '../components_bit/ContentTitle'
  import Echarts from '@/components/Echarts'

  import {
    initOption
  } from '@/EchartsOptions'

  export default {
    name: 'cars',
    components: {
      ContentTitle,
      MiiTable,
      Echarts
    },
    methods: {},
    computed: {
      sourceDataType: {
        get () {
          return this.$store.getters.sourceDataType
        }
      },
      orderWeight: {
        get () {
          return this.$store.getters.orderWeight
        }
      },
      carOrders: {
        get () {
          let data = []
          if (this.show_order_car) {
            let customers = []
            let vm = this
            this.clusterCutomer.forEach(function (item) {
              if (item[0].slice(2) === vm.show_order_car.slice(2)) {
                customers = item.slice(1)
              }
            })
            this.orderWeight.forEach(function (item) {
              if (customers.indexOf(item.shop) > -1) {
                data.push(item)
              }
            })
          }
          return data
        }
      },
      echarts_option: {
        get () {
          let vm = this
          let datas = []
          this.carOrders.forEach(function (item) {
            vm.ths.forEach(function (one, index) {
              if (index > 0) {
                datas.push({value1: item.shop, value2: one.label, value3: item[one.key]})
              }
            })
          })
          return {option: initOption(datas, this.option), outOption: {style: this.option.style}}
        }
      },
      cars: {
        get () {
          let data = this.$store.getters.cars
          if (data.length > 0) {
            this.show_order_car = data[0]
          }
          return data
        },
        set (value) {
          return this.$store.dispatch('setCars', value)
        }
      },
      clusterCutomer: {
        get () {
          return this.$store.getters.clusterCutomer
        },
        set (value) {
          return this.$store.dispatch('setClusterCutomer', value)
        }
      },
      centroids: {
        get () {
          return this.$store.getters.centroids
        },
        set (value) {
          return this.$store.dispatch('setCentroids', value)
        }
      },
      ths: {
        get () {
          let ths = [{
            key: 'shop'
          },
          {
            key: 'dry'
          },
          {
            key: 'Fresh'
          },
          {
            key: 'frozen'
          }]
          let labels = this.$store.getters.sourceDataField[this.$store.getters.sourceDataType]
          ths.forEach(function (item) {
            item.label = labels[item.key]
          })
          return ths
        }
      }
    },
    data () {
      return {
        show_order_car: '',
        datas: [],
        option: {
          chartType: 'bar',
          dataX: 'value1',
          dataY: 'value3',
          dataZ: 'value2',
          otherOption: {
            title: ''
          },
          style: ''
        },
        thsCentroids: [{
          label: '车辆名称',
          key: 'car_name'
        },
        {
          label: '中心点',
          key: 'center'
        },
        {
          label: '顾客数',
          key: 'customer_num'
        },
        {
          label: '订货数量',
          key: 'order_num'
        },
        {
          label: '总距离',
          key: 'distance'
        }]
      }
    }
  }
</script>
<style lang="less">
  .gu-duan .el-select .el-input .el-input__icon {
    background: #081633;
    color: #fff;
    width: 5em;
    transition: none;
  }
  .gu-duan .el-input__icon+.el-input__inner {
    padding-left: 2.3em;
  }
</style>

<style scoped lang="less">
  @import '../style/base.less';
  .two-content {
    display: flex;
  }

  .gu-duan {
    margin: 1.4em 0 1.2em;
    width: 100%;
    .el-select {
      width: 25em;
    }
  }
  .setting-content {
    .content-shadow;
    .content-bottom-radius;
    padding: 2.2em;
    display: flex;
    background-color: #fff;
    justify-content: space-between;
  }
  .model-setting {
    width: 31em;
    display: flex;
    flex-direction: column;
  }
  .one-model-setting {
    margin-bottom: 2.2em;
    justify-content: space-between;
    align-items: center;
    display: flex;
    span {
      font-size: 1em;
      color: @bak-color-1;
    }
    input:focus {
      outline:none;
    }
    input {
      margin-left: 2em;
      border: 1px solid #999;
      border-radius: 3px;
      padding: 2px;
      width: 14em;
      font-size: 1.13em;
      background-color: rgba(0, 0,0,0)
    }
  }
  .content-1 {
    width: 40em;
    margin-right: 3em;
  }
  .content-2 {
    .content-radius;
    .content-shadow;
    flex: 1;
    height: 21em;
    display: flex;
    background-color: #fff;
    flex-direction: column;
  }
  .car-echart {
    flex: 1;
  }
  .one-model-last {
    margin-bottom: 0em;
  }
  .checkbox-content {
    padding: 1.38em 2.2em;
    display: flex;
    flex-direction: column;
    span {
      line-height: 1;
      font-size: 0.8em;
      color: @bak-color-2;
    }
  }
  .m-line {
    width: 2px;
    border-right: 2px solid #ccc;
  }
  .setting-note {
    padding-right: 2em;
    width:50em;
    line-height: 2;
    color: @bak-color-2;
    font-size: 0.88em;
  }
  .checkbox-one {
    display: flex;
    align-items: center;
    height: 2.5em;
    font-size: 1em;
    color:@bak-color-1;
    img {
      padding: 0 1em;
    }
  }
</style>



// WEBPACK FOOTER //
// cars.vue?b877231e